module.exports = __webpack_public_path__ + "b68c1e71503e30bc643fe49dfd4236f7.png";